import { FC, default as React } from 'react';
import styled from 'styled-components';
import { Icon } from '../../../concepts/resources/Icon';
import { Button, Colors, Prompt } from '../../../ui';
import { Sebastian } from '../../canvas/ui/Sebastian';
import { Copy, Flexer, Title } from '../../dashboard/elements/LayoutElements';
import { Popup, PopupProps } from '../../popups/Popup';

const SpeechBubble = styled.div`
    padding: 1.5rem;
    border-radius: 0.9375rem;
    background: #F5F5F5; 
`;

type PopupAction = { label: string, onClick: () => void };

export const tutorialPopup = (title: string, copy: string | string[], action: string | PopupAction[]) =>
    ({ ui: TutorialPopup, fade: false, args: { title, copy, action } });

export const TutorialPopup: FC<PopupProps> = ({ dismiss, args }) => {
    const { title, action } = args;
    const copy = Array.isArray(args.copy) ? args.copy : [args.copy];
    return <Prompt ignoreEnter onAction={dismiss}>
        <Popup p="0" shadow="lg" style={{ overflow: 'hidden', borderRadius: '1rem' }}>
            <Flexer flex="column" padding="2" gap="1">
                <Flexer flex center>
                    <Title flush weight={500} size="2xl" color={Colors.text}>{title}</Title>
                </Flexer>
                <Flexer flex="row">
                    <Sebastian stance="teach" size="6" />
                    <div style={{ marginTop: '3.25rem' }}>
                        <Icon color='#F5F5F5' size="1.5" src="deqo://icons/deqo/speech" />
                    </div>
                    <SpeechBubble>
                        <Flexer flex="column" gap=".5" maxWidth="24">
                            {copy.map(x => <Copy flush color='#627496' key={x}>{x}</Copy>)}
                        </Flexer>
                    </SpeechBubble>
                </Flexer>
                <Flexer flex="row" center gap="2.5">
                    {typeof action === 'string' ? <Button size="xl" variant="mystery" onAction={dismiss}>{action}</Button> :
                        action.map(({ label, onClick }) =>
                            <Button key={label} size="xl" variant="mystery" onAction={() => { onClick(); dismiss(); }}>{label}</Button>)
                    }
                </Flexer>
            </Flexer>
        </Popup>
    </Prompt >;
};
